import { BaseCrudService } from "@/services/base";
import { Feature } from "@/swagger/models";

class FeatureService extends BaseCrudService<Feature> {
    constructor() {
        super({
            apiPrefix: "features",
            entityName: "feature",
        });
    }
}

export const featureService = new FeatureService();
